module.exports = __webpack_public_path__ + "img/case52-jpg.060e0e69.jpg";